import styled from 'styled-components';

export const SuperListContainer = styled.div`
  .search-not-found {
    text-align: center;
    opacity: 0.8;
    margin-top: 32px;
    color: ${({ theme }) => theme.colors.primary};
  }

  .search-description {
    text-align: center;
    padding: 24px;
    opacity: 0.7;
    color: ${({ theme }) => theme.colors.primary};

    .search-description-icon {
      font-size: 1.4rem;
      margin: 6px;
      margin-bottom: 12px;
    }

    .search-description-text {
      max-width: 260px;
      margin: 0 auto;
    }
  }

  .search-loading {
    text-align: center;
    padding: 24px;
    opacity: 0.7;
    color: ${({ theme }) => theme.colors.primary};

    .search-loading-icon {
      font-size: 1.6rem;
      margin: 6px;
      margin-bottom: 12px;
    }
  }

  .selected-items-title {
    opacity: 0.8;
    margin-bottom: 8px;
    font-size: 0.9rem;
    text-transform: uppercase;
  }

  .ant-btn {
    background: transparent !important;
  }

  footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    color: ${({ theme }) => theme.colors.text1};

    > span {
      opacity: 0.7;
    }

    .button-clear {
      margin: 0 4px;
    }
  }
`;
